import { render, staticRenderFns } from "./ChooseImage.vue?vue&type=template&id=fb273c86&scoped=true&"
import script from "./ChooseImage.vue?vue&type=script&lang=ts&"
export * from "./ChooseImage.vue?vue&type=script&lang=ts&"
import style0 from "./ChooseImage.vue?vue&type=style&index=0&id=fb273c86&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb273c86",
  null
  
)

export default component.exports